import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnitFormatterPipe } from './locale-formatter.pipe';



@NgModule({
  declarations: [UnitFormatterPipe],
  imports: [
    CommonModule
  ],
  exports: [UnitFormatterPipe]
})
export class UnitFormatterModule { }
